/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class EdisonSoundConfig implements ISoundConfig {

    public static instance:EdisonSoundConfig = new EdisonSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig"
    MAIN_GAME_AMBIANCE:string = "background-music-main";
    FREESPIN_AMBIANCE:string = "background-music-fs";

    // REELS_SPIN_START?:string[];
    // REELS_SPINNING:string = "reelSpinning";
    FS_ANTICIPATION:string = "anticipation";
    ANTICIPATION:string = "anticipation2";
    ANTICIPATION_FAIL:string = "anticipationFail";
    SCATTER_LANDING_1:string = "scatter-land1";
    SCATTER_LANDING_2:string = "scatter-land2";
    SCATTER_LANDING_3:string = "scatter-land3";
    WILD_LANDING:string = "wild_land";
    REELS_SPINNING_START_ON_SPIN_START:string = "reelSpinning";
    REELS_BOUNCE:string = "reelLanding";
    // REELS_DEFAULT_STOP?:string[];

    COUNT_UP:string = "countup";
    COUNT_UP_ENDS:string = "countup-ends";
    BIG_WIN_LEVEL_1:string = "bigWinSmall";
    BIG_WIN_LEVEL_2:string = "bigWinMedium";
    BIG_WIN_LEVEL_3:string = "bigWinLarge";
    BIG_WIN_END:string = "bigWinEnd";

    WIN_EFFECT_TINY:string = "win-tiny";
    WIN_EFFECT_SMALL:string = "win-small";
    WIN_EFFECT_MEDIUM:string = "win-medium";
    WIN_EFFECT_LARGE:string = "win-large";

    FS_METER_APPEAR_1:string = "fs-intro-meters-appear1";
    FS_METER_APPEAR_2:string = "fs-intro-meters-appear2";
    FS_METER_APPEAR_3:string = "fs-intro-meters-appear3";
    FS_METER_MOVE:string = "meter-multiplier-flash";

    FS_INTRO:string = "fs-intro";
    FS_OUTRO:string = "fs-outro";

    FS_METER_FLASH:string = "meter-filled-flashes";
    FS_METER_FILLED:string = "meter-filled";
    FS_METER_UPDATE:string = "meter-updated";
    FS_METER_SWOOSH:string = "meter-drained-whoosh";
    FS_METER_DRAINED:string = "meter-drained";
    FS_M_SYM_LANDING:string = "meter-symbol-land";

    RESPIN_INTRO:string = "respinIntro";

    BETTY_INTRO:string = "triggerRandomFeature-betty";
    BUGSY_INTRO:string = "triggerRandomFeature-bugsy";
    BETTY_BUGSY_INTRO_CLOSE:string = "triggerRandomFeature-close";

    BETTY_LANDING:string = "betty-stackedLanding";
    BUGSY_LANDING:string = "bugsy-stackedLanding";

    M_TURN_GOLD:string = "bugsy-stackedLanding";

    STACKED_TRANSFORM:string = "3symbolTransform";

    constructor() {
        if(EdisonSoundConfig.instance) {
            throw new Error("EdisonSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}